import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import '../../publisher/style/Navbar.css';

const Navbar = ({ name, role }) => {
    const navigate = useNavigate();
    const location = useLocation();
    
    // --- State ---
    const [isSidebarOpen, setIsSidebarOpen] = useState(false); // Default closed on mobile
    const [connectionStatus, setConnectionStatus] = useState('online'); // 'online', 'connecting', 'offline'
    const [scrolled, setScrolled] = useState(false);

    // --- Network Status Logic ---
    useEffect(() => {
        const handleOnline = () => {
            setConnectionStatus('connecting'); // Show "Connecting..." briefly before normal title
            setTimeout(() => setConnectionStatus('online'), 1500);
        };
        const handleOffline = () => setConnectionStatus('offline'); // Show "Updating..."

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        // Scroll listener for glass effect intensity
        const handleScroll = () => setScrolled(window.scrollY > 20);
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    // Get Initials for Avatar (e.g., "John Doe" -> "JD")
    const getInitials = (fullName) => {
        if (!fullName) return 'U';
        const names = fullName.split(' ');
        if (names.length === 1) return names[0].charAt(0).toUpperCase();
        return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
    };

    // Toggle Sidebar
    const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

    // Dynamic Title Renderer
    const renderTitle = () => {
        if (connectionStatus === 'offline') return <span className="nav-status-text blink-unique">Updating...</span>;
        if (connectionStatus === 'connecting') return <span className="nav-status-text fade-unique">Connecting...</span>;
        
        return (
            <span className="site-title-unique animated-breath-unique">
                CashBolt <span className="accent-text">Media</span>
            </span>
        );
    };

    return (
        <>
            {/* --- TOP NAVBAR --- */}
            <div className={`navbar-wrapper-unique ${scrolled ? 'scrolled' : ''}`}>
                
                {/* Left: Toggle & Title */}
                <div className="nav-left-section">
                    <button className="sidebar-toggle-btn" onClick={toggleSidebar}>
                        {/* Hamburger SVG */}
                        <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="3" y1="12" x2="21" y2="12"></line>
                            <line x1="3" y1="6" x2="21" y2="6"></line>
                            <line x1="3" y1="18" x2="21" y2="18"></line>
                        </svg>
                    </button>

                    <div className="nav-brand-container">
                        {renderTitle()}
                    </div>
                </div>

                {/* Right: Profile Avatar */}
                <div className="nav-right-section">
                    <div 
                        className="user-avatar-circle" 
                        onClick={() => navigate('/profile')}
                        title="Go to Profile"
                    >
                        {getInitials(name)}
                    </div>
                </div>
            </div>

            {/* --- SIDEBAR IMPORTED HERE --- */}
            <Sidebar 
                isOpen={isSidebarOpen} 
                toggle={toggleSidebar} 
                currentPath={location.pathname}
                role={role} // Pass role to sidebar
            />
            
            {/* Spacer to prevent content from hiding behind fixed navbar */}
            <div className="navbar-spacer-unique"></div>
        </>
    );
};

export default Navbar;